import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../utils/api';
import './DoctorLogin.css';

const DoctorLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await api.post('/auth/doctor/login', { email, password });
      const { doctorId, role, accessToken, refreshToken, accountStatus } = response.data;
      if (accountStatus === 'deleted') {
        setError('Your account has been deleted. Please contact support.');
        return;
      }
      login({ id: doctorId, role, accessToken, refreshToken });
      navigate(`/doctor-dashboard/${doctorId}`);
    } catch (error) {
      setError(error.response?.data?.error || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="login-page">
      <div className="auth-container">
        <h2>Doctor Login</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>
        <p>
          <button
            onClick={() => navigate('/doctor/forgot-password')}
            className="forgot-password-link"
          >
            Forgot Password?
          </button>
        </p>
        <p>
          Don&apos;t have an account?{' '}
          <button onClick={() => navigate('/doctor-register')} className="register-link">
            Register here
          </button>
        </p>
      </div>
    </div>
  );
};

export default DoctorLogin;